import { axiosHelper } from '../../..';
import { AxiosMethods } from '../../../../enums';

enum AnalyticsKeys {
  Create = 'create-analytics'
}

export const captureAnalyticsMutation = () => ({
  mutationKey: [AnalyticsKeys.Create],
  mutationFn: ({
    body,
    endpoint
  }: {
    body: { [key: string]: any };
    endpoint: string;
  }) =>
    axiosHelper({
      endpoint,
      method: AxiosMethods.POST,
      baseURL: process.env.REVOPS_API,
      body
    })
});
